import Cookies from 'js-cookie'

export function clearSession() {
  Cookies.remove('fftk')
  Cookies.remove('fftk', { domain: '.fanfou.mogita.rocks' })
}
